import React from 'react';
import './style.scss';
import GroupOffIcon from "../../../../Utils/Icons/SVGs/GroupOffIcon";


export default function GroupedOrdersOptions(props) {
  const onGroupOffClicked = (e) => {
    if (props.onGroupOffClicked)
      props.onGroupOffClicked(e);
  };

  return (
    <div className="grouped-orders-options">
            <span className="group-off-icon-container" onClick={onGroupOffClicked} aria-label="Edit">
                <div className="group-off-icon">
                    <GroupOffIcon fontSize="medium"/>
                </div>
            </span>
    </div>
  );
}
